import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-528fc601"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-17 ant-col-xl-17" }, null, -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_4 = {
  key: 0,
  class: "ss-movimento-comercial-cabecalho-fixo"
}
const _hoisted_5 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_6 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-movimento-comercial-campo-totalizador",
  style: {"padding":"10px 10px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "ant-col ant-col-xs-1 ant-col-xl-1 ss-movimento-comercial-campo-totalizador" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Itens", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Produtos", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Frete", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_31 = { style: {"color":"white"} }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sim", -1))
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_36 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-3",
  rules: [{ required: true }]
}
const _hoisted_37 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-4",
  rules: [{ required: true }]
}
const _hoisted_38 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_39 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_40 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_43 = { class: "ant-input-group-wrapper" }
const _hoisted_44 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_45 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px","background-color":"transparent","border":"none!important"}
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "ant-col ant-col-xs-8 ant-col-xl-1" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_50 = { class: "ant-col ant-col-xs-12 ant-col-xl-9" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_53 = { class: "ant-row" }
const _hoisted_54 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_55 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_56 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_59 = { class: "ant-input-group-wrapper" }
const _hoisted_60 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_61 = {
  class: "ant-input-group-addon",
  style: {"padding":"0px","background-color":"transparent","border":"none!important"}
}
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_63 = { class: "ant-row" }
const _hoisted_64 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_65 = { class: "ant-row" }
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_selecionar_origem_nota_fiscal = _resolveComponent("selecionar-origem-nota-fiscal")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_tipo_emissao = _resolveComponent("selecionar-tipo-emissao")!
  const _component_selecionar_finalidade = _resolveComponent("selecionar-finalidade")!
  const _component_selecionar_tipo_emissao_n_fe = _resolveComponent("selecionar-tipo-emissao-n-fe")!
  const _component_selecionar_tipo_emissao_n_f_ce = _resolveComponent("selecionar-tipo-emissao-n-f-ce")!
  const _component_selecionar_indicador_presenca = _resolveComponent("selecionar-indicador-presenca")!
  const _component_selecionar_modelo_documento_fiscal = _resolveComponent("selecionar-modelo-documento-fiscal")!
  const _component_selecionar_situacao_documento_fiscal = _resolveComponent("selecionar-situacao-documento-fiscal")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_cenario_fiscal = _resolveComponent("selecionar-cenario-fiscal")!
  const _component_selecionar_marcador_nota_fiscal = _resolveComponent("selecionar-marcador-nota-fiscal")!
  const _component_card = _resolveComponent("card")!
  const _component_barra_progresso = _resolveComponent("barra-progresso")!
  const _component_nota_fiscal_itens = _resolveComponent("nota-fiscal-itens")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_impostos = _resolveComponent("nota-fiscal-impostos")!
  const _component_nota_fiscal_frete = _resolveComponent("nota-fiscal-frete")!
  const _component_nota_fiscal_descontos_acrescimos = _resolveComponent("nota-fiscal-descontos-acrescimos")!
  const _component_venda_detalhes_pagamento = _resolveComponent("venda-detalhes-pagamento")!
  const _component_nota_fiscal_detalhes_pagamento = _resolveComponent("nota-fiscal-detalhes-pagamento")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_nota_fiscal_documentos_referenciados = _resolveComponent("nota-fiscal-documentos-referenciados")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_nota_fiscal_anexos = _resolveComponent("nota-fiscal-anexos")!
  const _component_nota_fiscal_historico = _resolveComponent("nota-fiscal-historico")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_requisitar_autorizacao_modal = _resolveComponent("requisitar-autorizacao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile ? 'full-modal ss-modal-nota-fiscal-eletronica' : _ctx.state.notaFiscal.codigo === 0 ? 'ss-modal-nota-fiscal-eletronica' : 'scroll-modal ss-modal-nota-fiscal-eletronica'
  }, {
    title: _withCtx(() => [
      _createTextVNode("Nota Fiscal Eletrônica")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      ((!_ctx.modalBase.apresentarBarraProgresso || !_ctx.state.incluindoCabecalhoNotaFiscal))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              ((_ctx.state.notaFiscal.codigo > 0))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.verificaSePodeExcluir())
                      ? (_openBlock(), _createBlock(_component_a_tooltip, {
                          key: 0,
                          placement: "top",
                          title: "Excluir"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "excluir" })
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                type: "primary",
                size: "large",
                class: "ss-btn-acao-destaque",
                loading: _ctx.state.carregando || _ctx.state.carregandoItens,
                onClick: _ctx.salvar
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.state.notaFiscal.codigo > 0 ? 'Salvar' : 'Continuar'), 1)
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 10 }
      }, {
        default: _withCtx(() => [
          ((_ctx.state.notaFiscal.codigo > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      style: _normalizeStyle('color: white; font-size: 11px; background-color: ' + _ctx.servicoNotaFiscal.corStatus(_ctx.state.notaFiscal.status) + '!important;'),
                      value: _ctx.servicoNotaFiscal.descricaoStatus(_ctx.state.notaFiscal.status),
                      disabled: "true"
                    }, null, 12, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.state.notaFiscal.itens.length,
                      disabled: "true"
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalProdutos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalDesconto, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalFrete, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalSeguro, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalOutrasDespesas, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_26)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.valorTotalImpostos, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_29)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_a_popover, {
                      placement: "top",
                      title: "Incidência no Total da Nota Fiscal"
                    }, {
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.incidenciasCalculo, (incidencia, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: incidencia.incidencia + index
                          }, [
                            (incidencia.incidencia === 'TotalNota')
                              ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                  key: 0,
                                  style: {"margin-left":"0px!important"},
                                  checked: incidencia.valor,
                                  "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                  onChange: _ctx.atualizarValoresTotais
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["checked", "onUpdate:checked", "onChange"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_31, [
                          _createTextVNode("Total da Nota Fiscal "),
                          _createVNode(_component_icone, {
                            class: "ss-icone-informacao-campo",
                            nome: "informacoes-fp"
                          })
                        ]),
                        _createElementVNode("input", {
                          type: "text",
                          class: "ant-input hidden ss-movimento-input-totalizador",
                          style: {"background-color":"#000066","color":"white","font-weight":"900","font-size":"20px"},
                          value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.notaFiscal.totalNotaFiscal, 2, true),
                          disabled: "true"
                        }, null, 8, _hoisted_32)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.state.cacheDisponivel && _ctx.state.editavel)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      type: "warning",
                      "show-icon": "",
                      closable: ""
                    }, {
                      message: _withCtx(() => [
                        _createTextVNode(" Você possui uma versão mais recente desta Nota Fiscal salvo de forma automática, deseja recuperar? "),
                        _createVNode(_component_a_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.recuperarCacheRegistro())),
                          size: "small",
                          type: "text"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.state.atualizarApenasInformacoesFiscais)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 1,
                      type: "info",
                      "show-icon": "",
                      closable: ""
                    }, {
                      message: _withCtx(() => [
                        _createTextVNode(" Esta nota fiscal possui regras quer permite que você atualize somente alguns campos e informações fiscais para emissão de NF-e/NFC-e ou geração do SPED. ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_a_form_item, {
                        label: "Origem",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_origem_nota_fiscal, {
                            valor: _ctx.state.notaFiscal.origemNotaFiscal,
                            "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.notaFiscal.origemNotaFiscal) = $event)),
                            disabled: ""
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Operação",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_operacao, {
                            valor: _ctx.state.notaFiscal.tipoOperacao,
                            "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.notaFiscal.tipoOperacao) = $event)),
                            rules: [{ required: true }],
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo Emissão",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_emissao, {
                            valor: _ctx.state.notaFiscal.tipoEmissao,
                            "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.notaFiscal.tipoEmissao) = $event)),
                            onChange: _ctx.verificaAlteracaoTipoEmissao,
                            rules: [{ required: true }],
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                          }, null, 8, ["valor", "onChange", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_a_form_item, {
                        label: "Finalidade",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_finalidade, {
                            valor: _ctx.state.notaFiscal.finalidade,
                            "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.notaFiscal.finalidade) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_a_form_item, {
                        label: "Modalidade",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          (_ctx.state.notaFiscal.modelo === '55')
                            ? (_openBlock(), _createBlock(_component_selecionar_tipo_emissao_n_fe, {
                                key: 0,
                                valor: _ctx.state.notaFiscal.modalidadeEmissao,
                                "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.notaFiscal.modalidadeEmissao) = $event)),
                                disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                              }, null, 8, ["valor", "disabled"]))
                            : (_openBlock(), _createBlock(_component_selecionar_tipo_emissao_n_f_ce, {
                                key: 1,
                                valor: _ctx.state.notaFiscal.modalidadeEmissao,
                                "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.notaFiscal.modalidadeEmissao) = $event)),
                                disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                              }, null, 8, ["valor", "disabled"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_a_form_item, {
                        label: "Indicador Presença",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_indicador_presenca, {
                            valor: _ctx.state.notaFiscal.indicadorPresenca,
                            "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.notaFiscal.indicadorPresenca) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, [
                          _createElementVNode("span", _hoisted_45, [
                            _createVNode(_component_icone, {
                              class: "ss-icone",
                              style: 'color: #a0aec1;padding: 8px;background-color: #ebeff2;border-radius: 3px;',
                              nome: "numero"
                            })
                          ]),
                          _createVNode(_component_a_form_item, {
                            label: "Número",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.notaFiscal.numeroNotaFiscal) = $event)),
                                disabled: (_ctx.state.notaFiscal.tipoEmissao === _ctx.ETipoEmissao.EmissaoPropria)
                              }, null, 8, _hoisted_46), [
                                [_vModelText, _ctx.state.notaFiscal.numeroNotaFiscal]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_a_form_item, {
                        label: "Série",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.notaFiscal.serie) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.salvarCacheRegistro()))
                          }, null, 40, _hoisted_48), [
                            [_vModelText, _ctx.state.notaFiscal.serie]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_a_form_item, {
                        label: "Modelo",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_modelo_documento_fiscal, {
                            valor: _ctx.state.notaFiscal.modelo,
                            "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.notaFiscal.modelo) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_a_form_item, {
                        label: "Chave de Acesso",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.notaFiscal.chaveAcesso) = $event)),
                            disabled: (_ctx.state.notaFiscal.tipoEmissao === _ctx.ETipoEmissao.EmissaoPropria)
                          }, null, 8, _hoisted_51), [
                            [_vModelText, _ctx.state.notaFiscal.chaveAcesso]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_a_form_item, {
                        label: "Situação do documento",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_situacao_documento_fiscal, {
                            valor: _ctx.state.notaFiscal.situacao,
                            "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.notaFiscal.situacao) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_a_form_item, {
                        label: "Data de Emissão",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            horaMinuto: true,
                            dataSelecionada: _ctx.state.notaFiscal.dataEmissao,
                            "onUpdate:dataSelecionada": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.notaFiscal.dataEmissao) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                            onChange: _ctx.salvarCacheRegistro
                          }, null, 8, ["dataSelecionada", "disabled", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_a_form_item, {
                        label: "Data Entrada Saída",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            horaMinuto: true,
                            dataSelecionada: _ctx.state.notaFiscal.dataEntradaSaida,
                            "onUpdate:dataSelecionada": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.notaFiscal.dataEntradaSaida) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                            onChange: _ctx.salvarCacheRegistro
                          }, null, 8, ["dataSelecionada", "disabled", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_a_form_item, {
                        label: "Data do Registro",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            horaMinuto: true,
                            dataSelecionada: _ctx.state.notaFiscal.dataRegistro,
                            "onUpdate:dataSelecionada": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.notaFiscal.dataRegistro) = $event)),
                            disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal(),
                            onChange: _ctx.salvarCacheRegistro
                          }, null, 8, ["dataSelecionada", "disabled", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("span", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, [
                          _createElementVNode("span", _hoisted_61, [
                            _createVNode(_component_icone, {
                              class: "ss-icone",
                              style: 'color: #a0aec1;padding: 8px;background-color: #ebeff2;border-radius: 3px;',
                              nome: "cliente"
                            })
                          ]),
                          (_ctx.state.notaFiscal.tipoEmissao === _ctx.ETipoEmissao.EmissaoPropria)
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 0,
                                label: "Pessoa",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_pessoa, {
                                    classCss: "ss-selecionar-pessoa-modal",
                                    codigoSelecionado: _ctx.state.notaFiscal.destinatario.codigoPessoa,
                                    "onUpdate:codigoSelecionado": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.notaFiscal.destinatario.codigoPessoa) = $event)),
                                    recursoOrigem: "NOTAS_FISCAIS",
                                    empresas: [_ctx.state.notaFiscal.codigoEmpresa],
                                    disabled: !_ctx.state.editavel,
                                    apresentarRelacoes: false,
                                    limparSelecao: false,
                                    onChange: _ctx.atualizarInformacoesPessoa,
                                    onKeydown: [
                                      _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                      _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                      _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                    ]
                                  }, null, 8, ["codigoSelecionado", "empresas", "disabled", "onChange"])
                                ]),
                                _: 1
                              }))
                            : (_ctx.state.notaFiscal.tipoEmissao === _ctx.ETipoEmissao.EmissaoTerceiro)
                              ? (_openBlock(), _createBlock(_component_a_form_item, {
                                  key: 1,
                                  label: "Pessoa",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_pessoa, {
                                      classCss: "ss-selecionar-pessoa-modal",
                                      codigoSelecionado: _ctx.state.notaFiscal.emitente.codigoPessoa,
                                      "onUpdate:codigoSelecionado": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.notaFiscal.emitente.codigoPessoa) = $event)),
                                      recursoOrigem: "NOTAS_FISCAIS",
                                      empresas: [_ctx.state.notaFiscal.codigoEmpresa],
                                      disabled: !_ctx.state.editavel,
                                      apresentarRelacoes: false,
                                      limparSelecao: false,
                                      onChange: _ctx.atualizarInformacoesPessoa,
                                      onKeydown: [
                                        _cache[23] || (_cache[23] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                        _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                        _cache[25] || (_cache[25] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                      ]
                                    }, null, 8, ["codigoSelecionado", "empresas", "disabled", "onChange"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_a_form_item, {
                        label: "Cenário Fiscal",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_cenario_fiscal, {
                            codigoSelecionado: _ctx.state.codigoCenarioFiscal,
                            "onUpdate:codigoSelecionado": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.codigoCenarioFiscal) = $event)),
                            empresas: [_ctx.state.notaFiscal.codigoEmpresa],
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_a_form_item, {
                        label: "Marcadores",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_marcador_nota_fiscal, {
                            marcadoresSelecionados: _ctx.state.marcadores,
                            "onUpdate:marcadoresSelecionados": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                            onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.salvarCacheRegistro())),
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["marcadoresSelecionados", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, { titulo: " " }, {
                default: _withCtx(() => [
                  ((_ctx.state.notaFiscal.codigo === 0 && _ctx.state.incluindoCabecalhoNotaFiscal))
                    ? (_openBlock(), _createBlock(_component_barra_progresso, {
                        key: 0,
                        visivel: _ctx.state.incluindoCabecalhoNotaFiscal,
                        frase: 'Aguarde por favor... Estamos buscando as regras, tributações e informações para sua Nota Fiscal ocorrer corretamente.'
                      }, null, 8, ["visivel", "frase"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.notaFiscal.codigo > 0)
                    ? (_openBlock(), _createBlock(_component_a_tabs, {
                        key: 1,
                        defaultActiveKey: "1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tab_pane, {
                            key: "1",
                            tab: "PRODUTOS"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_nota_fiscal_itens, {
                                codigoCenarioFiscal: _ctx.state.codigoCenarioFiscal,
                                tipoOperacao: _ctx.state.notaFiscal.tipoOperacao,
                                dadosPessoaMovimento: _ctx.state.dadosPessoaMovimento,
                                key: _ctx.state.chaveItens,
                                "tabelas-precos": _ctx.state.tabelasPrecosDisponiveis,
                                totalNotaFiscal: _ctx.state.notaFiscal.totalNotaFiscal,
                                atualizarValores: _ctx.state.atualizarValores,
                                incidencias: _ctx.state.notaFiscal.incidenciasCalculo,
                                itens: _ctx.state.notaFiscal.itens,
                                "onUpdate:itens": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.notaFiscal.itens) = $event)),
                                editavel: _ctx.state.editavel,
                                buscarDadosFiscaisRecalcular: _ctx.state.buscarDadosFiscaisRecalcular,
                                "onUpdate:buscarDadosFiscaisRecalcular": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.buscarDadosFiscaisRecalcular) = $event)),
                                atualizarApenasInformacoesFiscais: _ctx.state.atualizarApenasInformacoesFiscais,
                                adicionarPrimeiroItem: _ctx.state.adicionarPrimeiroItem,
                                dadosAdicionais: _ctx.state.notaFiscal.dadosAdicionais,
                                "onUpdate:dadosAdicionais": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.notaFiscal.dadosAdicionais) = $event)),
                                onItemAlterado: _ctx.atualizarValoresTotais,
                                carregando: _ctx.state.carregandoItens
                              }, null, 8, ["codigoCenarioFiscal", "tipoOperacao", "dadosPessoaMovimento", "tabelas-precos", "totalNotaFiscal", "atualizarValores", "incidencias", "itens", "editavel", "buscarDadosFiscaisRecalcular", "atualizarApenasInformacoesFiscais", "adicionarPrimeiroItem", "dadosAdicionais", "onItemAlterado", "carregando"]))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "2",
                            tab: "IMPOSTOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_impostos, {
                                impostos: _ctx.state.notaFiscal.totalImpostos,
                                "onUpdate:impostos": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.notaFiscal.totalImpostos) = $event)),
                                incidenciasCalculo: _ctx.state.incidenciasCalculo,
                                "onUpdate:incidenciasCalculo": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.incidenciasCalculo) = $event)),
                                onTotalAlterado: _ctx.atualizarValoresTotais,
                                editavel: false
                              }, null, 8, ["impostos", "incidenciasCalculo", "onTotalAlterado"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "3",
                            tab: "FRETE"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_frete, {
                                notaFiscal: _ctx.state.notaFiscal,
                                "onUpdate:notaFiscal": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.notaFiscal) = $event)),
                                editavel: _ctx.state.editavel,
                                mostrarOutrosValores: false,
                                onTotalAlterado: _ctx.atualizarValoresTotais
                              }, null, 8, ["notaFiscal", "editavel", "onTotalAlterado"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "4",
                            tab: "DESCONTOS E ACRÉSCIMOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_descontos_acrescimos, {
                                notaFiscal: _ctx.state.notaFiscal,
                                "onUpdate:notaFiscal": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.notaFiscal) = $event)),
                                editavel: _ctx.state.editavel,
                                onTotalAlterado: _ctx.atualizarValoresTotais,
                                onPercentualDescontoAlterado: _ctx.atualizarDescontoGeral,
                                onDescontoAlterado: _ctx.atualizarDescontoGeral
                              }, null, 8, ["notaFiscal", "editavel", "onTotalAlterado", "onPercentualDescontoAlterado", "onDescontoAlterado"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "5",
                            tab: "DETALHES DO PAGAMENTO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_spin, {
                                spinning: _ctx.state.carregando
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_venda_detalhes_pagamento, {
                                    venda: _ctx.state.notaFiscal,
                                    "onUpdate:venda": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.notaFiscal) = $event)),
                                    totalCaixa: _ctx.state.totalCaixaLancado,
                                    "onUpdate:totalCaixa": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.totalCaixaLancado) = $event)),
                                    totalCarteira: _ctx.state.totalCarteiraLancado,
                                    "onUpdate:totalCarteira": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.totalCarteiraLancado) = $event)),
                                    totalOutros: _ctx.state.totalOutrosLancado,
                                    "onUpdate:totalOutros": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.totalOutrosLancado) = $event)),
                                    editavel: _ctx.state.editavel,
                                    onAdicionarTaxas: _ctx.adicionarTaxasPagamento,
                                    onRemoverTaxas: _ctx.removerTaxasPagamento
                                  }, null, 8, ["venda", "totalCaixa", "totalCarteira", "totalOutros", "editavel", "onAdicionarTaxas", "onRemoverTaxas"]),
                                  _createVNode(_component_nota_fiscal_detalhes_pagamento, {
                                    empresa: _ctx.state.notaFiscal.codigoEmpresa,
                                    totalDetalhesPagamento: _ctx.state.totalDetalhesPagamento,
                                    "onUpdate:totalDetalhesPagamento": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.totalDetalhesPagamento) = $event)),
                                    detalhesPagamento: _ctx.state.notaFiscal.detalhesPagamento,
                                    "onUpdate:detalhesPagamento": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.notaFiscal.detalhesPagamento) = $event)),
                                    editavel: _ctx.state.editavel,
                                    onAtualizarDetalhePagamento: _ctx.atualizarDetalhePagamento
                                  }, null, 8, ["empresa", "totalDetalhesPagamento", "detalhesPagamento", "editavel", "onAtualizarDetalhePagamento"])
                                ]),
                                _: 1
                              }, 8, ["spinning"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "6",
                            tab: "DOCUMENTOS REFERENCIADOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_documentos_referenciados, {
                                visivel: true,
                                codigoRegistro: _ctx.state.notaFiscal.codigo,
                                editavel: _ctx.state.editavel,
                                documentos: _ctx.state.notaFiscal.documentosReferenciadosDfe,
                                "onUpdate:documentos": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.notaFiscal.documentosReferenciadosDfe) = $event))
                              }, null, 8, ["codigoRegistro", "editavel", "documentos"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "7",
                            tab: "OBSERVAÇÕES"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Dados Adicionais",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_editor_html, {
                                        value: _ctx.state.notaFiscal.dadosAdicionais,
                                        "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.notaFiscal.dadosAdicionais) = $event)),
                                        onChange: _ctx.salvarCacheRegistro,
                                        disabled: _ctx.verificaEdicaoCampoEInformacaoFiscal()
                                      }, null, 8, ["value", "onChange", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "8",
                            tab: "ANEXOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_spin, {
                                spinning: _ctx.state.carregando
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_anexos, {
                                    codigoRegistro: _ctx.state.notaFiscal.codigo,
                                    empresa: _ctx.state.notaFiscal.codigoEmpresa,
                                    editavel: _ctx.state.editavel,
                                    anexos: _ctx.state.notaFiscal.anexos,
                                    "onUpdate:anexos": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.notaFiscal.anexos) = $event)),
                                    onAtualizarAnexo: _ctx.atualizarAnexo,
                                    onExcluirAnexo: _ctx.excluirAnexo
                                  }, null, 8, ["codigoRegistro", "empresa", "editavel", "anexos", "onAtualizarAnexo", "onExcluirAnexo"])
                                ]),
                                _: 1
                              }, 8, ["spinning"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "9",
                            tab: "HISTÓRICO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_spin, {
                                spinning: _ctx.state.carregando
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_nota_fiscal_historico, {
                                    registros: _ctx.state.registrosAtividade
                                  }, null, 8, ["registros"])
                                ]),
                                _: 1
                              }, 8, ["spinning"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_requisitar_autorizacao_modal, {
        visivel: _ctx.requisicaoAutorizacaoBase.exibirRequisicao,
        "onUpdate:visivel": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.requisicaoAutorizacaoBase.exibirRequisicao) = $event)),
        "identificador-permissao": _ctx.requisicaoAutorizacaoBase.permissao,
        descricao: _ctx.requisicaoAutorizacaoBase.descricao,
        onAutorizada: _cache[47] || (_cache[47] = ($event: any) => {_ctx.buscarItensDadosAtualizados();}),
        onNegada: _cache[48] || (_cache[48] = ($event: any) => {_ctx.buscarItensDadosAtualizados();})
      }, null, 8, ["visivel", "identificador-permissao", "descricao"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}